import { get } from "lodash";
import { PaymentMethodEnum } from "../../enum/payment-method.enum";

type TransactionType = "valuation" | "admin";

export class ProcessPayment{
  application_uuid: string;
  payment_mode: PaymentMethodEnum | undefined;
  transaction_types: TransactionType[];
  
  constructor(initial?: ProcessPayment){
    this.application_uuid = get(initial, 'application_uuid', "");
    this.payment_mode     = get(initial, 'payment_mode', undefined);
    this.transaction_types = get(initial, 'transaction_types', []);
  }

  setApplicationUUID(application_uuid:string = ""){
    this.application_uuid = application_uuid;
  }
  
  setPaymentMode(payment_mode:PaymentMethodEnum){
    this.payment_mode = payment_mode;
  }
  
  addTransactionType(transaction_type: TransactionType){
    this.transaction_types.push(transaction_type);
  }
  
  json(){
    return this;
  }


}
